const LoaderPage = () => {
    return (     
        <div id="m-loading">
            <div className="preloader"></div>
        </div>  
    );
};

export default LoaderPage;